/**
 * Created by sivanh on 14/06/2018.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var BaseCollection = require("collections/BaseCollection");
    var ScheduleUtilities = require("utils/ScheduleUtilities");

    var ScheduleEventModel = require("models/entities/scheduling/ScheduleEventModel");

    var ScheduleEventsCollection = BaseCollection.extend({
        model: ScheduleEventModel,

        comparator: function(model) {
            var days = ScheduleUtilities.DAYS;
            var daysOrder = [days.MONDAY,days.TUESDAY,days.WEDNESDAY,days.THURSDAY,days.FRIDAY,days.SATURDAY,days.SUNDAY];

            var eventIndex = _.indexOf(daysOrder, model.id);

            return eventIndex;
        },

        validate : function () {
            var errors = {};

            this.each(function(scheduleEventModel) {
                var modelErrors = scheduleEventModel.validate();
                if (modelErrors) {
                    errors[scheduleEventModel.id] = modelErrors;
                }
            });

            return errors;
        }
    });

    ScheduleEventsCollection.Model = ScheduleEventModel;

    return ScheduleEventsCollection;

});
